import {useAppSelector} from '@/hooks';
import {getIsCurrentPagePlaying} from '@Components/poster-editor/poster-editor-reducer';
import {useSingleActivePosterItem} from '@Hooks/poster-editor/useSingleActivePosterItem';

export function useShouldHideControlsWhenItemAnimating(pageHashedId: string): boolean {
  const isPosterPlaying = useAppSelector(getIsCurrentPagePlaying);

  const activeItem = useSingleActivePosterItem(pageHashedId);
  const isActiveItemAnimating = isPosterPlaying && activeItem?.hasAnimation() === true;

  return isActiveItemAnimating;
}

export function useShouldHideHoveredItemControlsWhenAnimating(pageHashedId: string): boolean {
  const hoveredItemId = useAppSelector((state) => state.posterEditor.hoveredItemId[pageHashedId]);
  const hoveredItem = hoveredItemId ? window.posterEditor?.whiteboard?.getItemForId(hoveredItemId) : undefined;

  return hoveredItem?.introAnimation?.animation?.isAnimationPlaying ?? false;
}
